// src/app/notifications/notifications.module.ts
// ─────────────────────────────────────────────────────────────────────────────
// OPTIONAL: Use this module if you want lazy-loading.
// Otherwise, register the components directly in AppModule (see notes below).
// ─────────────────────────────────────────────────────────────────────────────
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { NotificationListComponent } from './notification-list/notification-list.component';
import { NotificationsPageComponent } from './notifications-page/notifications-page.component';
import { NotificationService } from './notification.service';

const routes: Routes = [
  { path: '', component: NotificationsPageComponent }
];

@NgModule({
  declarations: [
    NotificationListComponent,
    NotificationsPageComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
  exports: [
    NotificationListComponent,   // exported so TopbarComponent can use <app-notification-list>
  ],
  providers: [NotificationService]
})
export class NotificationsModule {}

